import { HiOutlineExclamationTriangle } from "react-icons/hi2";

interface DocumentDownloadErrorModalProps {
  title: string;
  description: string;
  understoodLabel: string;
  contactLabel: string;
  onUnderstood: () => void;
  onContact: () => void | Promise<void>;
}

export function DocumentDownloadErrorModal({
  title,
  description,
  understoodLabel,
  contactLabel,
  onUnderstood,
  onContact,
}: DocumentDownloadErrorModalProps) {
  return (
    <div
      className="fixed inset-0 z-[10000] flex items-center justify-center bg-[#003d66]/35 px-4 py-6 backdrop-blur-[2px]"
      role="dialog"
      aria-modal="true"
      aria-labelledby="document-download-error-title"
    >
      <div className="w-full max-w-[22rem] rounded-xl bg-white px-6 py-7 text-center shadow-[0_18px_55px_rgba(0,61,102,0.24)]">
        <div className="mx-auto flex h-11 w-11 items-center justify-center rounded-none bg-[#fff1f1] text-[#ed6b73]">
          <HiOutlineExclamationTriangle className="h-6 w-6" aria-hidden="true" />
        </div>
        <h2 id="document-download-error-title" className="mt-4 text-lg font-bold text-[#003d66]">
          {title}
        </h2>
        <p className="mt-2 text-[0.7rem] leading-relaxed text-black">
          {description}
        </p>
        <div className="mt-5 flex gap-2">
          <button
            type="button"
            className="flex-1 rounded-sm bg-[#007acc] px-3 py-2.5 text-xs font-medium text-white transition-colors hover:bg-[#0066aa]"
            onClick={onUnderstood}
          >
            {understoodLabel}
          </button>
          <button
            type="button"
            className="flex-1 rounded-sm border border-[#9ec9e1] bg-white px-3 py-2.5 text-xs font-semibold text-[#168bc7] transition-colors hover:bg-[#f0f8ff]"
            onClick={onContact}
          >
            {contactLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
